import { useEffect } from "react";

export default function usePageMeta({ title, description, robots = "index, follow", canonical, ogType = "website", ogDescription = description, twitterDescription = description }) {
  useEffect(() => {
    document.title = title;
    const setMeta = (name, content) => {
      let element = document.querySelector(`meta[name="${name}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.name = name;
        document.head.appendChild(element);
      }
      element.content = content;
    };
    setMeta("description", description);
    setMeta("robots", robots);
    // ServiceBoss has a share image, so keep the large card the prerendered head set.
    setMeta("twitter:card", document.documentElement.dataset.brand === "serviceboss" ? "summary_large_image" : "summary");
    setMeta("twitter:title", title);
    setMeta("twitter:description", twitterDescription);

    const setPropertyMeta = (property, content) => {
      let element = document.querySelector(`meta[property="${property}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("property", property);
        document.head.appendChild(element);
      }
      element.content = content;
    };
    setPropertyMeta("og:title", title);
    setPropertyMeta("og:description", ogDescription);
    setPropertyMeta("og:type", ogType);

    if (canonical) {
      let element = document.querySelector('link[rel="canonical"]');
      if (!element) {
        element = document.createElement("link");
        element.rel = "canonical";
        document.head.appendChild(element);
      }
      element.href = canonical;
      setPropertyMeta("og:url", canonical);
    }
  }, [title, description, robots, canonical, ogType, ogDescription, twitterDescription]);
}
